import { Outlet } from "react-router-dom";
import { ThemeProvider } from "@trillion/ui/theme/theme-provider";
import { AppAuthProvider } from "@trillion/auth";
import { Toaster } from "@trillion/ui/components/ui/sonner";
import { TooltipProvider } from "@trillion/ui/components/ui/tooltip";
import { Alert, AlertDescription, AlertTitle } from "@trillion/ui/components/ui/alert";
import { getEnv } from "@trillion/ui/lib/env";
import { AlertTriangle } from "lucide-react";
import { resolveBoardMcpEndpoint } from "../lib/board-mcp-guide";

export function RootLayout() {
  const boardApiUrl = getEnv("BOARD_API_URL").trim();
  const boardApiUrlResult = resolveBoardMcpEndpoint(boardApiUrl);

  return (
    <ThemeProvider>
      <TooltipProvider>
        {boardApiUrlResult.ok ? (
          <AppAuthProvider authUrl={boardApiUrl} product="board" clientVariant="web">
            <div className="antialiased">
              <Outlet />
            </div>
          </AppAuthProvider>
        ) : (
          <main className="flex min-h-screen items-center justify-center p-4 antialiased">
            <Alert className="max-w-xl" variant="destructive">
              <AlertTriangle aria-hidden="true" />
              <AlertTitle>Board configuration error</AlertTitle>
              <AlertDescription>{boardApiUrlResult.message}</AlertDescription>
            </Alert>
          </main>
        )}
      </TooltipProvider>
      <Toaster />
    </ThemeProvider>
  );
}
